import { Action, createReducer, on } from '@ngrx/store';
import {
  addCartItemAction,
  addCartItemSuccessAction,
  ClearStateAction,
  deleteAllCartItemAction,
  deleteAllCartItemErrorAction,
  deleteCartItemAction,
  deleteCartItemSuccessAction,
  getCartAction,
  getCartErrorAction,
  getCartSuccessAction,
  loadCartSuccessAction,
  setAccountID,
  setCartStartTimeAction,
  setCartUnAvailabilItemsAction,
  updateCartItemAction,
  updateCartItemErrorAction,
  updateCartItemSuccessAction,
} from './cart.actions';
import { CartState } from './cart.state';

const initialState = new CartState();

const reducer = createReducer(
  initialState,
  on(getCartAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getCartSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.cart = payload.cart;
    return newState;
  }),
  on(getCartErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(addCartItemAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(addCartItemSuccessAction, (state, { cartItemIndex, cartItem }) => {
    const newState = { ...state };
    newState.isLoading = false;

    const cartItems = [...state.cart];

    if (cartItemIndex >= 0) {
      cartItems[cartItemIndex] = cartItem;
      newState.cart = cartItems;
    } else {
      newState.cart = [...newState.cart, cartItem];
    }

    return newState;
  }),
  // on(addCartItemErrorAction, (state, payload) => {
  //   const newState = { ...state };
  //   newState.isLoading = false;
  //   newState.failures = payload.failure;
  //   return newState;
  // }),

  on(deleteCartItemAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(deleteCartItemSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.cart = newState.cart.filter((item, index) => {
      if (index !== payload.cart.index) {
        return item;
      }
    });
    return newState;
  }),
  // on(addCartItemErrorAction, (state) => {
  //   const newState = { ...state };
  //   newState.isLoading = false;
  //   return newState;
  // }),

  on(deleteAllCartItemAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  // on(deleteAllCartItemSuccessAction, (state, payload) => {
  //   const newState = { ...state };
  //   newState.cart = state.cart.map((newsItem) => {
  //     if (newsItem.id === payload.cart.id) {
  //       return [newsItem, payload.cart];
  //     }
  //   });
  //   newState.isLoading = false;
  //   return newState;
  // }),
  on(deleteAllCartItemErrorAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    return newState;
  }),

  on(updateCartItemAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(updateCartItemSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;

    newState.cart = newState.cart.map((newsItem, index) => {
      if (newsItem.productID === payload.cart.productID && index === payload.cart.index) {
        newsItem = payload.cart;
        return newsItem;
      }
      return newsItem;
    });
    return newState;
  }),
  on(updateCartItemErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(loadCartSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    if (payload.cart) {
      newState.cart = payload?.cart ? payload.cart : [];
    }
    return newState;
  }),
  on(setCartUnAvailabilItemsAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.cartUnAvailabilItems = payload.items;
    return newState;
  }),
  on(setAccountID, (state, { accountID }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.accountID = accountID;
    return newState;
  }),
  on(setCartStartTimeAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.cartStartTime = new Date().toISOString();
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'cart':
        newState.cart = [];
        break;
      case 'cartStartTime':
        newState.cartStartTime = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function CartReducer(state: CartState | null, action: Action) {
  return reducer(state, action);
}
